import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { BadgeModel } from "@insite/client-framework/Types/ApiModels";
import Badge from "@insite/mobius/Badge";
import X from "@insite/mobius/Icons/X";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useState } from "react";
import { css } from "styled-components";
import { BadgeTypeValues } from "@insite/client-framework/Types/ApiModels";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { connect } from "react-redux";

interface Props {
    badgeList: BadgeModel[];
    maxBadges: number;
    extendedStyles?: ProductTextBadgesStyles;
}

export interface ProductTextBadgesStyles {
    container?: InjectableCss;
    badge?: InjectableCss;
    badgeText?: TypographyPresentationProps;
}
const mapStateToProps = (state: ApplicationState) => ({
    customSettings: getSettingsCollection(state).customSettings,
});
type Prop = Props & ReturnType<typeof mapStateToProps>;

export const productTextBadgesStyles: ProductTextBadgesStyles = {
    badge: {
        css: css`
            margin-top: 5px;
        `,
    },
    badgeText: {
        weight: "bold",
        size: 15,
        css: css`
            width: 100%;
            margin: auto;
            ${wrapInContainerStyles}
        `,
    },
};

const ProductTextBadges = ({ badgeList, maxBadges, extendedStyles,customSettings }: Prop) => {
    const [styles] = useState(() => mergeToNew(productTextBadgesStyles, extendedStyles));
    const [isVisibleTooltip, setIsVisibleTooltip] = useState(false);
    const setting = customSettings as any;
    const tags = setting ? setting.plpBadgeTagNameList.split(',') : [];
    //const tags = ["PLP"];

    

    const arrCopy = badgeList ? [...badgeList] : [];
    let badgesOrder = arrCopy?.sort((a, b) => a.sortOrder - b.sortOrder);

    let textBadges = badgesOrder?.filter(
        badge => badge.displayOnBadgeWidget && badge.badgeType === BadgeTypeValues.Text && badge.displayText,
    );

    if (tags && tags.length > 0) {
        textBadges = textBadges?.filter(
            badge => tags.findIndex((tag: string) => tag.toLowerCase() === badge.tagName.toLowerCase()) > -1,
        );
    }

    const handleMouseEnterTooltip = () => {
        setIsVisibleTooltip(true);
    };
    
    const handleMouseLeaveTooltip = () => {
        setIsVisibleTooltip(false);
    };
    
    const handleCloseClickTooltip = () => {
        setIsVisibleTooltip(false);
    };
    return (
        <StyledWrapper {...styles.container} data-test-selector="textBadges">
            {textBadges.slice(0, maxBadges).map(badge => (
                <StyledWrapper key={badge.id} {...styles.badge}>
                    <StyledWrapper className="tooltipBadgeWrapper" onMouseEnter={handleMouseEnterTooltip} onMouseLeave={handleMouseLeaveTooltip}>
                        <Badge
                            type={badge.badgeType}
                            value={badge.displayText}
                            badgeTextColor={badge.textColorHexCode}
                            badgeBackgroundColor={badge.badgeColorHexCode}
                            badgeTextRounding={badge.badgeStyle === "Round" ? 20 : 0}
                            textBadgeCss={styles.badgeText}
                            {...styles.badge}
                        />
                        {isVisibleTooltip && (
                            <StyledWrapper className="tooltipBadgeText">
                                <Typography>
                                    {badge.name}
                                </Typography>
                                <Typography className="close-button" onClick={handleCloseClickTooltip}>
                                    <X/>
                                </Typography>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
            ))}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(ProductTextBadges);

